// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"fQ-z","categoryName":"gQ-z","categoryNameSearchHeader":"hQ-z","categoryContent":"iQ-z","bottomAligned":"jQ-z","image":"kQ-z","imageNoBackground":"lQ-z"};